
export function CoreValuesSection() {
  const values = [
    {
      icon: "ri-brain-line",
      title: "Deep Industry Knowledge",
      description: "Our team brings years of upstream exploration experience, deeply understanding industry bottlenecks and commercial logic to ensure solutions directly address pain points."
    },
    {
      icon: "ri-cpu-line",
      title: "Cutting-edge Technology Integration", 
      description: "Proficient in AI, big data, HPC, and cloud computing, excelling at creative fusion with traditional geosciences for innovative breakthrough solutions."
    },
    {
      icon: "ri-global-line",
      title: "Global Delivery Excellence",
      description: "Leveraging Singapore as our hub, we integrate global resources with service networks covering Middle East, Asia-Pacific, and North America for efficient localized delivery."
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-slate-900/50 to-slate-800/50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
            Core <strong className="text-blue-400">Values</strong>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Three pillars that define our approach to delivering exceptional technology solutions
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {values.map((value, index) => (
            <div 
              key={index}
              className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-500 hover:transform hover:scale-105"
            >
              <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-blue-500/30 transition-colors duration-300">
                <i className={`${value.icon} text-2xl text-blue-400`}></i>
              </div>
              
              <h3 className="text-xl font-semibold text-white mb-4">
                {value.title}
              </h3>
              
              <p className="text-white/70 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
